export default function getUtilityData(utility, data_type) {
    let utilityData;
    if(data_type === "KPI"){
        switch(utility){
            case "water":
                utilityData = {
                    "icon":"fas fa-tint",
                    "unitMeasurement":"L/kg",
                    "color":"#46c1c7"
                }
                break;

        case "energy":
            utilityData = {
                "icon":"fas fa-lightbulb",
                "unitMeasurement":"KwH/kg",
                "color":"#85c14d"
            }
            break;

        case "gas":
            utilityData = {
                "icon":"fas fa-fire-alt",
                "unitMeasurement":"m³/kg",
                "color":"#f89a10"
            }
            break;

        case "steam":
            utilityData = {
                "icon":"fas fa-cloud",
                "unitMeasurement":"kg/kg",
                "color":"#dddddd"
            }
            break;

        case "air":
            utilityData = {
                "icon":"fas fa-wind",
                "unitMeasurement":"m³/kg",
                "color":"#c3e3fa"
            }
        }
    }

    if(data_type === "CONSUMPTION"){
        console.log("AQUI1")
        switch(utility){
            case "water":
                utilityData = {
                    "icon":"fas fa-tint",
                    "unitMeasurement":"m³",
                    "color":"#46c1c7"
                }
                break;

        case "energy":
            utilityData = {
                "icon":"fas fa-lightbulb",
                "unitMeasurement":"KwH",
                "color":"#85c14d"
            }
            break;

        case "gas":
            utilityData = {
                "icon":"fas fa-fire-alt",
                "unitMeasurement":"m³",
                "color":"#f89a10"
            }
            break;

        case "steam":
            utilityData = {
                "icon":"fas fa-cloud",
                "unitMeasurement":"kg",
                "color":"#dddddd"
            }
            break;

        case "air":
            utilityData = {
                "icon":"fas fa-wind",
                "unitMeasurement":"m³",
                "color":"#c3e3fa"
            }
        }
    }

    return utilityData

}